export const DATAGRID_PAGE_SIZE_OPTIONS:number[] = [10, 25, 100];
export const DATAGRID_DEFAULT_PAGE_SIZE:number = 10;
